import { useState } from 'react';

/**
 * Hook personalizado para gerenciar o estado de modais de confirmação
 * @returns {Object} Controles e estados do modal de confirmação
 */
const useConfirmationModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: '',
    message: '',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    onConfirm: () => {},
    onCancel: () => {},
    onClose: () => {},
    type: 'default' // default, danger, warning, success
  });

  /**
   * Exibe o modal de confirmação com as configurações especificadas
   * @param {Object} config Configurações do modal
   */
  const showConfirmationModal = (config) => {
    setModalConfig({
      ...modalConfig,
      ...config,
      onClose: config.onClose || hideConfirmationModal
    });
    setIsModalOpen(true);
  };

  /**
   * Fecha o modal de confirmação
   */
  const hideConfirmationModal = () => {
    setIsModalOpen(false);
  };

  /**
   * Executa a ação de cancelamento e fecha o modal
   */
  const handleCancel = () => {
    if (modalConfig.onCancel) {
      modalConfig.onCancel();
    }
    hideConfirmationModal();
  };

  /**
   * Executa a ação de confirmação e fecha o modal
   */
  const handleConfirm = () => {
    if (modalConfig.onConfirm) {
      modalConfig.onConfirm();
    }
    hideConfirmationModal();
  };

  /**
   * Executa a ação de fechamento (X) e fecha o modal
   */
  const handleClose = () => {
    if (modalConfig.onClose) {
      modalConfig.onClose();
    }
    hideConfirmationModal();
  };

  return {
    isModalOpen,
    modalConfig,
    showConfirmationModal,
    hideConfirmationModal,
    handleCancel,
    handleConfirm,
    handleClose
  };
};

export default useConfirmationModal; 